import { css } from 'styled-components';
import styled from 'styled-components';

export const PageShell = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
`;

export const HeroPanel = styled.section`
  background:
    radial-gradient(
      circle at top left,
      ${(props) => `${props.theme.colors.primary}12`},
      transparent 28%
    ),
    linear-gradient(
      180deg,
      ${(props) => `${props.theme.colors.primary}08`},
      ${(props) => props.theme.colors.surface}
    );
  border: 1px solid ${(props) => `${props.theme.colors.primary}20`};
  border-radius: 1rem;
  color: ${(props) => props.theme.colors.onSurface};
  padding: 1rem 1.15rem;

  h2,
  p {
    margin: 0;
  }

  h2 {
    font-size: 1.35rem;
    margin-bottom: 0.45rem;
  }

  p {
    line-height: 1.6;
    max-width: 72ch;
  }
`;

export const FiltersRow = styled.div`
  display: grid;
  gap: 0.85rem;
  grid-template-columns: minmax(0, 2fr) minmax(220px, 1fr);

  @media (max-width: 860px) {
    grid-template-columns: 1fr;
  }
`;

const fieldStyles = css`
  background: ${(props) => props.theme.colors.surface};
  border: 1px solid ${(props) => `${props.theme.colors.onSurface}28`};
  border-radius: 0.9rem;
  box-sizing: border-box;
  color: ${(props) => props.theme.colors.onSurface};
  font-size: 0.95rem;
  padding: 0.9rem 1rem;
  width: 100%;

  &::placeholder {
    color: ${(props) => `${props.theme.colors.onSurface}88`};
  }
`;

export const SearchInput = styled.input`
  ${fieldStyles}
`;

export const CategorySelect = styled.select`
  ${fieldStyles}
`;

export const ContentGrid = styled.div`
  display: grid;
  gap: 1rem;
  grid-template-columns: minmax(300px, 360px) minmax(0, 1fr);

  @media (max-width: 1080px) {
    grid-template-columns: 1fr;
  }
`;

export const ListPanel = styled.aside`
  display: flex;
  flex-direction: column;
  gap: 0.85rem;
  max-height: calc(100vh - 18rem);
  overflow: auto;
  padding-right: 0.2rem;

  @media (max-width: 1080px) {
    max-height: none;
    overflow: visible;
  }
`;

export const ContentCard = styled.button<{ active?: boolean }>`
  background: ${(props) => (
    props.active ? `${props.theme.colors.primary}14` : props.theme.colors.surface
  )};
  border: 1px solid ${(props) => (props.active
    ? `${props.theme.colors.primary}66`
    : `${props.theme.colors.onSurface}18`)};
  border-radius: 1rem;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  gap: 0.7rem;
  padding: 1rem;
  text-align: left;
  transition: transform 0.18s ease, border-color 0.18s ease, background 0.18s ease;

  &:hover {
    border-color: ${(props) => `${props.theme.colors.primary}88`};
    transform: translateY(-1px);
  }

  h3,
  p {
    margin: 0;
  }

  h3 {
    color: ${(props) => props.theme.colors.onSurface};
    font-size: 1rem;
  }

  p {
    color: ${(props) => props.theme.colors.text};
    font-size: 0.85rem;
    line-height: 1.55;
  }
`;

export const ContentCardMeta = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 0.45rem;
`;

export const ContentMetaBadge = styled.span<{ tone?: 'default' | 'primary' }>`
  background: ${(props) => (props.tone === 'primary'
    ? `${props.theme.colors.primary}18`
    : `${props.theme.colors.onSurface}10`)};
  border-radius: 999px;
  color: ${(props) => (
    props.tone === 'primary' ? props.theme.colors.primary : props.theme.colors.text
  )};
  font-size: 0.78rem;
  font-weight: 600;
  padding: 0.3rem 0.65rem;
`;

export const PreviewPanel = styled.section`
  background: ${(props) => props.theme.colors.surface};
  border: 1px solid ${(props) => `${props.theme.colors.onSurface}18`};
  border-radius: 1rem;
  min-height: 440px;
  padding: 1rem;
`;

export const EmptyState = styled.div`
  align-items: center;
  background: ${(props) => `${props.theme.colors.onSurface}05`};
  border: 1px dashed ${(props) => `${props.theme.colors.onSurface}25`};
  border-radius: 1rem;
  color: ${(props) => props.theme.colors.text};
  display: flex;
  flex-direction: column;
  gap: 0.7rem;
  justify-content: center;
  min-height: 260px;
  padding: 1.5rem;
  text-align: center;

  h3,
  p {
    margin: 0;
  }

  p {
    line-height: 1.6;
    max-width: 56ch;
  }
`;

export const ListCounter = styled.div`
  color: ${(props) => props.theme.colors.text};
  font-size: 0.9rem;
  font-weight: 600;
`;

export const InlineButtonWrapper = styled.span`
  display: inline-flex;
`;
